import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Header } from "./components/header/Header";
import { TopPan } from "./components/topPan/TopPan";
import { Home } from "./components/home/Home";
import VideoPlayerPage from "./components/videoplayerpage/videoPlayerPage";
import { SplashScreen } from "./components/splashscreen/SplashScreen";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // fake startup delay (like fetching config, auth, etc.)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // 2 seconds
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <SplashScreen />; // 👈 show splash first
  }

  return (
    // <>
    //   <Header />
    //   <TopPan />
    //   <Home />
    //  </>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/player" element={<VideoPlayerPage />} />
      </Routes>
    </Router>
  );
}

export default App;
